import React from 'react';
import './ExportButton.style.scss';
import { RootState } from '../../../../Redux/Store/store';
import { isEmpty } from 'ramda';
import { Observer, GLOBAL_EVENT } from '../../Observer';
import { useSelector } from 'react-redux';

const ExportButton = (props: any) => {
    const imagesFiles = useSelector((store: RootState) => store.imagesAtlas);
    // const emit_click = useSelector((store: RootState) => (store.imagesAtlas.length != 0));
    if(!isEmpty(imagesFiles)) {
        Observer.emit(GLOBAL_EVENT.NOTIFICATION_SYSTEM.CLEAR);
    }

    const handleClick = () => {
        
        if(isEmpty(imagesFiles)) {
            Observer.emit(GLOBAL_EVENT.NOTIFICATION_SYSTEM.WARNING, 'Please import an image');
        } else {
            // Subimos el evento al padre para guardar la imagen.
            props.handleClick();
        }
    }

    return (
        <button className={((isEmpty(imagesFiles)) ? `save-export-disable` : `save-export`) + ` noselect`} onClick={handleClick}>
            {props.title}
        </button>
    )
}

export default ExportButton;
